import { Box, Container } from '@mui/material';
import React, { Component } from 'react';
import { JobReport } from '../../JobReport';
import { JobProcessingBanner } from '../JobProcessingBanner';
import PortalPageHeader from '../../common/PortalPageHeader';
import { AdminPageDetails, PageDetails } from '../config';

class AutoAssignmentReport extends Component {
  state = {
    id: 'autoAssignmentReport',
    title: '',
    breadcrumbs: [],
  };

  componentDidMount() {
    this.loadPageTitle();
    this.loadBreadcrumbs();
  }

  //θ(N) where N is the number of pages in PageDetails
  //Retrieve page title from pageDetails using pageid
  loadPageTitle = () => {
    const page = Object.values(AdminPageDetails).find((page) => page.id === this.state.id);
    this.setState({
      title: page.title,
    });
  };

  loadBreadcrumbs = () => {
    const page = Object.values(AdminPageDetails).find((page) => page.id === this.state.id);
    this.setState({
      breadcrumbs: page.breadcrumbs,
    });
  };

  render() {
    const id = this.state.id;
    return (
      <React.Fragment>
        <div id={`${id}__div_pageWrapper`} className={`myOdu__${id}`} style={{}}>
          <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
            <PortalPageHeader
              id={this.state.id}
              title={this.state.title}
              breadcrumbs={this.state.breadcrumbs}
              banner={<JobProcessingBanner />}
            />

            <Box id={`${id}__box_wrapper`}>
              <JobReport id={this.state.id} widgetName="No Assignment Jobs Report" />
            </Box>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AutoAssignmentReport;
